<template>
  <div>
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——馆内简介</p>

      <div class="content">
        <div class="leftNav">
          <h2>栏目导航</h2>
          <div>
            <ul>

              <router-link :to="{name:'intro',params:{nav:'jianjie'}}" ><li :class="{active:activeIntroFlag}" @click="navCur('intro')">纪念馆简介</li></router-link>
              <router-link :to="{name:'honor',params:{nav:'jianjie'}}" ><li  :class="{active:activeHonorFlag}" @click="navCur('honor')">获得荣誉</li></router-link>
            </ul>
          </div>
        </div>
        <div class="rightCol">
          <div class="rightCol-c">
            <h2>
              <span>馆内简介</span>
            </h2>

          </div>
          <router-view></router-view>
        </div>
      </div>


    </div>

      <!--  底部模板  -->
      <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";


export default {
  name: "AboutYjj",
  components:{
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{

      activeIntroFlag:true,
      activeHonorFlag:false
    }
  },
  methods:{
    navCur(data){

      if(data == 'intro'){
        this.activeIntroFlag = true;
        this.activeHonorFlag = false;
      }
      if(data == 'honor'){
        this.activeHonorFlag = true;
        this.activeIntroFlag = false
      }
    }
  },
  mounted() {
    if(this.$route.name == 'intro'){
      this.activeIntroFlag = true;
      this.activeHonorFlag = false;
    }
    else{
      this.activeHonorFlag = true;
      this.activeIntroFlag = false
    }

  },
  metaInfo() {
    return {
      title: this.$route.meta.title || '东北抗日义勇军纪念馆'
    };
  }
}
</script>

<style scoped>
.container{
  width:70%;
  margin: 0 auto;
  padding:10px 0;
}
.active{
  color:#9E1A28;
  font-weight: bold;
}
.nav{
  text-align: left;
}
.content{
  display: flex;
  margin-top: 20px;
}
.content .leftNav{
  flex:1
}
.leftNav h2{
  color: white;
  height: 60px;
  line-height: 60px;
  background: #9E1A28;
}
.leftNav div{
  margin-top: 10px;
  border: 1px solid silver;
}
.leftNav div{
  padding-bottom: 20px;
}
.leftNav div ul{
  padding:0 20px;
}
.leftNav div ul li {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px silver dashed;
}
.leftNav div ul a{
  color: black;
  text-decoration: none;
}
.rightCol{
  flex: 4;

}
.rightCol-c{
  padding:10px 0 0 60px;
}
.rightCol-c h2{
  padding-bottom: 10px;
  border-bottom: 1px solid silver;
  text-align: left;
}
.rightCol-c h2 span{
  color: #9E1A28;
  padding-bottom: 6px;
  border-bottom: 5px solid #9E1A28;
}

</style>
